import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';

import File from '../../generic/File';
import { attachmentShape } from '../../prop-types';
import api from '../../REST/api';

function AttachmentsGrid({
  onDeleteFileSuccess,
  colCount,
  files,
  noDeleteOption,
}) {
  return (
    <div className={`d-grid grid-col-${colCount}`}>
      {files.map(file => {
        return (
          <File
            key={file.id}
            onGetFile={api.downloadAttachment}
            onDeleteFile={api.destroyAttachment}
            onDeleteFileSuccess={onDeleteFileSuccess}
            file={file}
            noDeleteOption={noDeleteOption}
          />
        );
      })}
    </div>
  );
}

AttachmentsGrid.propTypes = {
  onDeleteFileSuccess: func,
  files: arrayOf(attachmentShape.isRequired).isRequired,
  colCount: number,
  noDeleteOption: bool,
};

AttachmentsGrid.defaultProps = {
  noDeleteOption: false,
  onDeleteFileSuccess: null,
  colCount: 0,
};

export default AttachmentsGrid;
